import { render, staticRenderFns } from "./MsgForm.vue?vue&type=template&id=ab7363f8&scoped=true&"
import script from "./MsgForm.vue?vue&type=script&lang=js&"
export * from "./MsgForm.vue?vue&type=script&lang=js&"
import style0 from "./MsgForm.vue?vue&type=style&index=0&id=ab7363f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7363f8",
  null
  
)

export default component.exports